const useSharedStyles = {
  screen: (isMobile: boolean) => ({
    flex: 1,
    minHeight: 0,
    flexDirection: 'column',
    width: '100%',
    paddingX: isMobile ? 2 : 4,
    paddingTop: isMobile ? 4 : 3,
  }),
  form: {
    flex: 1,
    minHeight: 0,
    flexDirection: 'column',
    width: '100%',
    maxWidth: 390,
    marginX: 'auto',
  },
  intro: (isMobile: boolean) => ({
    flexDirection: 'column',
    gap: isMobile ? 1 : 0.25,
  }),
  title: () => ({
    fontWeight: 600,
  }),
  fields: (isMobile: boolean) => ({
    flexDirection: 'column',
    marginTop: isMobile ? 3 : 2,
  }),
  submitContainer: () => ({
    justifyContent: 'center',
    marginTop: 'auto',
    paddingTop: 4,
    paddingBottom: 5,
  }),
}

export default useSharedStyles
